export default __webpack_public_path__ + "static/media/vc1.21d95518.jpg";